/* ═══════════════════════════════════════════════════════════════
   EXANOVA — JS unique, sans dépendance, léger.
   Rôles : menu mobile, panier latéral, sélecteur de couleur/variante,
   galerie, accordéons, barre d'achat collante, révélations au scroll.
   Chaque bloc est autonome et se branche s'il trouve son markup.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ---------- 1. Révélations au scroll (subtiles, non bloquantes) ---------- */
  const reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- 1b. Hero vidéo : coupe l'autoplay si l'utilisateur réduit les animations ---------- */
  const heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    heroVideo.removeAttribute('autoplay');
    try { heroVideo.pause(); } catch (_) {}
  }

  /* ---------- 2. Accordéons (specs + FAQ), accessibles ---------- */
  document.querySelectorAll('.accordion__trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.style.height = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---------- 3. Panneaux latéraux : menu (à gauche) et panier (à droite) ----------
     Un seul panneau ouvert à la fois. Échap ou le voile le referment, la
     touche Tab reste dans le panneau, et le focus revient au bouton qui l'a
     ouvert. La page derrière ne défile plus pendant l'ouverture. */
  const html = document.documentElement;
  let opener = null;

  function focusables(el) {
    return Array.from(el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((n) => n.offsetWidth || n.offsetHeight || n.getClientRects().length);
  }
  function setExpanded(drawer, value) {
    document.querySelectorAll('[aria-controls="' + drawer.id + '"]').forEach((b) => b.setAttribute('aria-expanded', String(value)));
  }
  function openDrawer(drawer, from) {
    if (!drawer) return;
    const other = document.querySelector('[data-drawer].is-open');
    if (other && other !== drawer) closeDrawer(other, false);
    if (drawer.classList.contains('is-open')) return;
    opener = from || document.activeElement;
    drawer.hidden = false;
    html.classList.add('is-drawer-open');
    setExpanded(drawer, true);
    void drawer.offsetWidth; // pose l'état fermé avant de lancer la transition
    drawer.classList.add('is-open');
    const panel = drawer.querySelector('[role="dialog"]');
    if (panel) panel.focus({ preventScroll: true });
  }
  function closeDrawer(drawer, restoreFocus) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    setExpanded(drawer, false);
    html.classList.remove('is-drawer-open');
    const hide = () => { if (!drawer.classList.contains('is-open')) drawer.hidden = true; };
    const panel = drawer.querySelector('[role="dialog"]');
    if (panel) {
      // Seule la fin du glissement du panneau compte (pas celle d'un bouton survolé dedans)
      panel.addEventListener('transitionend', function done(e) {
        if (e.target !== panel) return;
        panel.removeEventListener('transitionend', done);
        hide();
      });
    }
    setTimeout(hide, 600); // filet : animations réduites, onglet en arrière-plan…
    if (restoreFocus !== false && opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-drawer]').forEach((drawer) => {
    drawer.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => closeDrawer(drawer)));
  });
  document.addEventListener('keydown', (e) => {
    const drawer = document.querySelector('[data-drawer].is-open');
    if (!drawer) return;
    if (e.key === 'Escape') { e.preventDefault(); closeDrawer(drawer); return; }
    if (e.key !== 'Tab') return;
    const panel = drawer.querySelector('[role="dialog"]');
    const items = focusables(panel);
    if (!items.length) { e.preventDefault(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- 3a. Menu (téléphone) ---------- */
  const menuDrawer = document.getElementById('MenuDrawer');
  if (menuDrawer) {
    document.querySelectorAll('[data-menu-open]').forEach((b) => b.addEventListener('click', () => openDrawer(menuDrawer, b)));
    // Passage en largeur ordinateur : la navigation est en ligne, le panneau se referme.
    const wide = window.matchMedia('(min-width: 760px)');
    const onWide = (e) => { if (e.matches) closeDrawer(menuDrawer, false); };
    if (wide.addEventListener) wide.addEventListener('change', onWide); else wide.addListener(onWide);
  }

  /* ---------- 3b. Panier latéral ----------
     Le contenu est écrit à partir de /cart.js : lignes, quantités, total.
     Il est préparé dès le chargement de la page, puis rafraîchi à chaque
     ouverture, pour s'afficher sans attente. */
  const cartDrawer = document.getElementById('CartDrawer');
  const live = document.getElementById('CartLiveRegion');
  let lastCart = null;

  // Prix au format de la boutique (Réglages → Devises), comme le filtre Liquid
  // « money » : le prix affiché par le JS est identique à celui de la page.
  function money(cents, currency, format) {
    const ph = /\{\{\s*(\w+)\s*\}\}/;
    if (format && ph.test(format)) {
      const delim = (precision, thousands, decimal) => {
        const parts = (cents / 100).toFixed(precision).split('.');
        return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
      };
      const kinds = {
        amount: () => delim(2, ',', '.'),
        amount_no_decimals: () => delim(0, ',', '.'),
        amount_with_comma_separator: () => delim(2, '.', ','),
        amount_no_decimals_with_comma_separator: () => delim(0, '.', ','),
        amount_with_space_separator: () => delim(2, ' ', ','),
        amount_no_decimals_with_space_separator: () => delim(0, ' ', ','),
        amount_with_apostrophe_separator: () => delim(2, "'", '.')
      };
      const kind = format.match(ph)[1];
      return format.replace(ph, (kinds[kind] || kinds.amount)());
    }
    try {
      return (cents / 100).toLocaleString(html.lang || 'fr',
        { style: 'currency', currency: currency || 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0 });
    } catch (_) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const sized = (url, w) => (url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  const plural = (n) => n + ' article' + (n > 1 ? 's' : '');

  async function getCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return res.ok ? await res.json() : null;
    } catch (_) { return null; }
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = n; });
    document.querySelectorAll('.cart-link[data-cart-open]').forEach((a) => a.setAttribute('aria-label', 'Panier, ' + plural(n)));
  }

  function renderCart(cart) {
    if (!cartDrawer || !cart) return;
    lastCart = cart;
    const body = cartDrawer.querySelector('[data-cart-body]');
    const foot = cartDrawer.querySelector('[data-cart-foot]');
    const count = cartDrawer.querySelector('[data-cart-title-count]');
    const fmt = cartDrawer.dataset.moneyFormat;
    if (count) count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.item_count) {
      const empty = cartDrawer.querySelector('[data-cart-empty]');
      body.innerHTML = empty ? empty.innerHTML : '';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = '<ul class="cart-drawer__items" role="list">' + cart.items.map((it) => {
      const variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      const name = esc(it.product_title);
      const alt = name + (variant ? ' — ' + esc(variant) : '');
      return '<li class="cart-drawer__item" data-line="' + esc(it.key) + '">' +
        '<a class="cart-drawer__thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
          (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="' + alt + '" width="120" height="150">' : '') +
        '</a>' +
        '<div class="cart-drawer__meta">' +
          '<a class="cart-drawer__name" href="' + esc(it.url) + '">' + name + '</a>' +
          (variant ? '<span class="cart-drawer__variant">' + esc(variant) + '</span>' : '') +
          '<span class="cart-drawer__price">' + money(it.final_line_price, cart.currency, fmt) + '</span>' +
          '<div class="cart-drawer__row">' +
            '<div class="cart-drawer__qty" role="group" aria-label="Quantité, ' + alt + '">' +
              '<button type="button" data-step="-1" aria-label="Retirer un exemplaire">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-step="1" aria-label="Ajouter un exemplaire">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" data-remove>Retirer</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }).join('') + '</ul>';
    const total = cartDrawer.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price, cart.currency, fmt);
    if (foot) foot.hidden = false;
  }

  async function changeLine(key, quantity, focusSel) {
    cartDrawer.classList.add('is-busy');
    let cart = null;
    let problem = '';
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const data = await res.json();
      if (res.ok) cart = data;
      else problem = (data && data.description) || '';
    } catch (_) {}
    if (!cart) cart = await getCart(); // échec (stock, réseau) : on réaffiche l'état réel
    cartDrawer.classList.remove('is-busy');
    if (!cart) return;
    renderCart(cart);
    setCount(cart.item_count);
    if (live) live.textContent = problem || (cart.item_count ? 'Panier mis à jour : ' + plural(cart.item_count) + '.' : 'Votre panier est vide.');
    const target = focusSel ? cartDrawer.querySelector(focusSel) : null;
    const panel = cartDrawer.querySelector('[role="dialog"]');
    (target || panel).focus({ preventScroll: true });
  }

  async function openCart(from, freshCart) {
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    if (freshCart || lastCart) renderCart(freshCart || lastCart);
    openDrawer(cartDrawer, from);
    if (freshCart) return;
    const cart = await getCart(); // rafraîchit (autre onglet, retour arrière…)
    if (cart) { renderCart(cart); setCount(cart.item_count); }
  }

  if (cartDrawer) {
    document.querySelectorAll('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      openCart(a);
    }));
    cartDrawer.addEventListener('click', (e) => {
      // Panier vide, sur la fiche du produit : le bouton referme simplement le panneau
      const cont = e.target.closest('[data-cart-continue]');
      if (cont && cont.pathname === window.location.pathname) { e.preventDefault(); closeDrawer(cartDrawer); return; }

      const btn = e.target.closest('[data-step], [data-remove]');
      const line = btn && btn.closest('[data-line]');
      if (!line || cartDrawer.classList.contains('is-busy')) return;
      const now = parseInt(line.querySelector('.cart-drawer__qty span').textContent, 10) || 0;
      if (btn.hasAttribute('data-remove')) { changeLine(line.dataset.line, 0, null); return; }
      const next = Math.max(0, now + parseInt(btn.dataset.step, 10));
      changeLine(line.dataset.line, next, next ? '[data-line="' + line.dataset.line + '"] [data-step="' + btn.dataset.step + '"]' : null);
    });
  }

  // Compteur d'en-tête et panneau prêts dès le chargement (et au retour arrière)
  function refreshCart() {
    getCart().then((cart) => { if (cart) { setCount(cart.item_count); renderCart(cart); } });
  }
  refreshCart();
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  /* ---------- 4. Fiches produit : la page produit et la section « Karya » de l'accueil ----------
     Variantes couleur + carrousel + ajout au panier. Chaque formulaire
     d'achat est autonome ; la barre collante n'appartient qu'à la fiche. */
  document.querySelectorAll('[data-product-form]').forEach(initProduct);

  function initProduct(productForm) {
    const root = productForm.closest('[data-product]');
    if (!root) return;
    let data = { variants: [] };
    try { data = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch (_) {}
    const isMain = root.hasAttribute('data-main-product');
    const idInput = productForm.querySelector('[name="id"]');
    const priceEls = Array.from(root.querySelectorAll('[data-price]'))
      .concat(isMain ? Array.from(document.querySelectorAll('.sticky-atc [data-price]')) : []);
    const swatches = root.querySelectorAll('.swatch');
    const labelEl = root.querySelector('[data-swatch-current]');
    const atcBtn = productForm.querySelector('[data-atc]');

    // Le carrousel prévient quand la photo change (doigt, flèches, points) :
    // si cette photo est celle d'un coloris, la pastille correspondante se coche.
    const carousel = initCarousel(root.querySelector('[data-carousel]'), (imageId) => {
      if (!imageId) return;
      const variant = data.variants.find((v) => v.featured_image && String(v.featured_image.id) === String(imageId));
      if (!variant || String(variant.id) === idInput.value) return; // photo d'ambiance, ou déjà sélectionné
      const sw = Array.from(swatches).find((s) => s.dataset.variantId === String(variant.id));
      if (sw) applySwatch(sw, false); // false : on ne re-défile pas, c'est le défilement qui nous appelle
    });

    // Barre d'achat collante (fiche produit seulement) : pastille, coloris, bouton, lien panier
    const stickyBtn = isMain ? document.querySelector('[data-sticky-atc]') : null;
    const stickyColor = isMain ? document.querySelector('[data-sticky-color]') : null;
    const stickyDot = isMain ? document.querySelector('[data-sticky-dot]') : null;
    const stickyCart = isMain ? document.querySelector('[data-sticky-cart]') : null;
    const buttons = [atcBtn, stickyBtn].filter(Boolean);

    // Les boutons (principal + barre collante) reflètent toujours le même état
    function setButtons(available) {
      buttons.forEach((b) => {
        b.disabled = !available;
        b.classList.remove('is-added');
        b.textContent = available ? b.dataset.labelDefault : b.dataset.labelSoldout;
      });
    }

    function syncSticky(sw) {
      if (stickyColor) stickyColor.textContent = sw.dataset.color || '';
      if (stickyDot) stickyDot.style.background = sw.style.background || '';
    }
    const initial = root.querySelector('.swatch[aria-checked="true"]');
    if (initial) syncSticky(initial);

    // Sélectionne un coloris : pastille, libellé, barre, formulaire, prix, boutons,
    // et (si demandé) fait défiler le carrousel jusqu'à sa photo.
    function applySwatch(sw, scrollCarousel) {
      swatches.forEach((s) => s.setAttribute('aria-checked', 'false'));
      sw.setAttribute('aria-checked', 'true');
      if (labelEl) labelEl.textContent = sw.dataset.color;
      syncSticky(sw);
      // L'identifiant de variante est écrit dans le formulaire AVANT tout le
      // reste : même si le JSON produit avait un souci, le bon coloris partirait.
      idInput.value = sw.dataset.variantId;
      const variant = data.variants.find((v) => String(v.id) === sw.dataset.variantId);
      if (!variant) return;
      priceEls.forEach((el) => { el.textContent = money(variant.price, data.currency, data.money_format); });
      if (scrollCarousel && variant.featured_image && carousel) carousel.goToImageId(variant.featured_image.id);
      setButtons(variant.available);
    }

    swatches.forEach((sw) => {
      sw.addEventListener('click', () => applySwatch(sw, true));
    });

    /* Ajout au panier en AJAX : le panier latéral s'ouvre avec l'article */
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      buttons.forEach((b) => { b.disabled = true; b.textContent = '…'; });
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: 1 })
        });
        if (res.status === 422) {
          // Coloris épuisé (ou stock insuffisant) : on le dit, on ne redirige pas.
          buttons.forEach((b) => { b.textContent = b.dataset.labelSoldout || 'Épuisé'; });
          setTimeout(() => setButtons(true), 2200);
          return;
        }
        if (!res.ok) throw new Error('cart');
        const item = await res.json();
        if (live) live.textContent = item.title + ' ajouté au panier.';
        buttons.forEach((b) => { b.textContent = b.dataset.labelAdded || 'Ajouté au panier'; b.classList.add('is-added'); });
        setTimeout(() => setButtons(true), 1600);
        const cart = await getCart();
        if (cart) setCount(cart.item_count);
        if (cartDrawer) openCart(atcBtn, cart);
        else if (stickyCart) stickyCart.hidden = false;
      } catch (_) {
        // Réseau ou JS en défaut : on laisse Shopify faire l'ajout classique.
        setButtons(true);
        productForm.submit();
      }
    });

    /* ---------- 5. Barre collante (apparaît quand le bouton principal sort de l'écran) ---------- */
    const sticky = isMain ? document.querySelector('.sticky-atc') : null;
    const anchor = root.querySelector('[data-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        const show = !entries[0].isIntersecting;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show)); // accessible seulement quand elle est visible
      }, { rootMargin: '-120px 0px 0px 0px' });
      io.observe(anchor);
      // Le bouton collant relaie le clic vers le formulaire d'achat principal
      if (stickyBtn) stickyBtn.addEventListener('click', () => atcBtn && atcBtn.click());
    }
  }

  /* ---------- 5b. Page panier : boutons +/- ajustent la quantité puis mettent à jour ---------- */
  const cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('.qty').forEach((box) => {
      const input = box.querySelector('[data-qty-input]');
      const step = (delta) => {
        const v = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = v;
        cartForm.submit(); // recharge /cart avec les nouvelles quantités
      };
      box.querySelector('[data-qty-minus]')?.addEventListener('click', () => step(-1));
      box.querySelector('[data-qty-plus]')?.addEventListener('click', () => step(1));
    });
  }

  /* ---------- 6. Carrousel produit (déclaration hoistée, utilisée plus haut) ----------
     onChange(imageId) est appelé à chaque changement de photo, quelle qu'en soit
     la cause (doigt, flèches, points, ou pastille de couleur). */
  function initCarousel(el, onChange) {
    if (!el) return null;
    const track = el.querySelector('[data-carousel-track]');
    const slides = Array.from(el.querySelectorAll('.carousel__slide'));
    if (!track || slides.length === 0) return null;

    const dotsWrap = el.querySelector('[data-carousel-dots]');
    let index = 0;
    let programmatic = false; // vrai pendant un défilement lancé par le code (pastille, flèche, point)
    const notify = () => { if (onChange) onChange(slides[index].dataset.imageId); };

    // Génère un point par slide
    const dots = slides.map((_, i) => {
      if (!dotsWrap) return null;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'carousel__dot';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(b);
      return b;
    });

    function syncDots() {
      dots.forEach((d, di) => d && d.setAttribute('aria-current', di === index ? 'true' : 'false'));
    }
    function goTo(i) {
      index = Math.max(0, Math.min(i, slides.length - 1));
      const target = index * track.clientWidth;
      // On annonce la DESTINATION tout de suite, une seule fois ; le trajet
      // (les photos traversées par le défilement fluide) ne déclenchera rien.
      if (Math.abs(track.scrollLeft - target) > 1) programmatic = true;
      track.scrollTo({ left: target, behavior: 'smooth' });
      syncDots();
      notify();
    }
    function goToImageId(id) {
      const i = slides.findIndex((s) => String(s.dataset.imageId) === String(id));
      if (i >= 0) goTo(i);
    }

    el.querySelector('[data-carousel-prev]')?.addEventListener('click', () => goTo(index - 1));
    el.querySelector('[data-carousel-next]')?.addEventListener('click', () => goTo(index + 1));

    // Défilement au doigt : les points suivent en direct, mais le coloris n'est
    // annoncé qu'une fois le mouvement TERMINÉ (140 ms sans événement), pour ne
    // pas faire défiler le texte à chaque photo traversée.
    let raf, settle;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { index = i; syncDots(); }
      });
      clearTimeout(settle);
      settle = setTimeout(() => {
        if (programmatic) { programmatic = false; return; } // c'est nous qui avons défilé : déjà annoncé
        notify();
      }, 140);
    }, { passive: true });

    return { goTo, goToImageId };
  }
})();